import { createActionConst } from '../../../utils/action.utils';

const MEETING_TEMPLATE_NAMESPACE = 'MEETING_TEMPLATE';

export const STORE_MEETING_TEMPLATE = createActionConst(MEETING_TEMPLATE_NAMESPACE, 'STORE_MEETING_TEMPLATE');
export const CLEAR_MEETING_TEMPLATE = createActionConst(MEETING_TEMPLATE_NAMESPACE, 'CLEAR_MEETING_TEMPLATE');
